import * as THREE from "three";

export class TriangleHelper {
    static TRIANGLE_GEOMETRY = new THREE.CylinderGeometry(0.4, 0.4, 0, 3);

    mesh;

    constructor() {
        const material = new THREE.MeshPhysicalMaterial({
            color: new THREE.Color(150, 150, 150),
        });
        this.mesh = new THREE.Mesh(TriangleHelper.TRIANGLE_GEOMETRY, material);
        this.mesh.position.y = 0.5 - 0.3 / 2;
    }

    setRotation(rotation) {
        this.mesh.rotation.y = rotation;
    }

    setPosition(position) {
        this.mesh.position.z = position;
    }
}